/**
 *
 * AddSubdivisionSelect
 *
 */

import React from "react"
import { Form, Select, Button, Tooltip } from "antd"
import "./index.less"

const FormItem = Form.Item

function AddSubdivisionSelect(props) {
  return (
    <FormItem style={{ marginBottom: 0 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "260px 90px",
          gridColumnGap: 7,
        }}>
        <Select
          style={{ height: 32 }}
          onChange={(event) =>
            props.changeSelectOption("valueOptionSelected", event)
          }
          showSearch
          value={props.valueOptionSelected}
          placeholder="Agregar subdivisión"
          allowClear
          filterOption={(input, option) => {
            return (
              option.props.children.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            )
          }}>
          {props.data.map((item) => {
            return (
              <Select.Option key={item.id_division} value={item.id_division}>
                <Tooltip title={item.name}>{item.name}</Tooltip>
              </Select.Option>
            )
          })}
        </Select>
        <Button
          className="buttonDisabled"
          style={{ fontSize: 13, paddingTop: 4 }}
          disabled={props.isButtonDisabled}
          type="primary"
          onClick={() => props.onAdd()}>
          + Agregar
        </Button>
      </div>
    </FormItem>
  )
}

AddSubdivisionSelect.propTypes = {}

export default AddSubdivisionSelect
